import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import NoteAltRoundedIcon from '@mui/icons-material/NoteAltRounded';
import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Drawer,
    styled,
    Button,
    IconButton,
    Typography,
    useMediaQuery,
    TextField,
    Grid,
    InputAdornment,
    Pagination
} from "@mui/material";
import { useQuery } from 'react-query';
import StickbotTop from './contentType/StickbotTop';
import NoAssignments from './IconsSvg/NoAssignments';
import { useStyles } from '../../utils/styles';
import { getAssignments } from '../_api/skilll-assignments';
import { isStatic } from './isStatic';
import ChatBot from './chatbot';
import GoalsModal from './GoalsModal';
import Notes from '../lessons/notes/Notes';
import StaticNotes from '../lessons/notes/StaticNotes';
import { useTheme } from '@mui/material/styles';
import StaticTodoList from '../lessons/notes/StaticTodoList';
import TodoList from '../lessons/notes/time-tracker/TodoList';
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import DictionaryDialog from './dictionary-dialog';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import AnalyticsDialog from './AnalyticsDialog';
const drawerWidth = "90%";
const StyledDrawer = styled(Drawer)(({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
        width: drawerWidth,
        boxSizing: "border-box",
        "&::-webkit-scrollbar": {
            width: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
        },
        [theme.breakpoints.down("sm")]: {
            height: "85%",
            width: "100%",
        },
    },

}));
function SkillAssignment() {
    const location = useLocation()
    const path = location.pathname
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { t, i18n } = useTranslation();
    const choosenLanguage = i18n.language == "en" ? "english" : "spanish";
    const [openTodoModal, setOpenTodoModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const getAssignmentType = () => {
        if (path.includes('/manage-budget')) {
            return 'manage-budget';
        } else if (path.includes('/boost')) {
            return 'boost';
        } else if (path.includes('/net-worth')) {
            return 'net-worth';
        } else if (path.includes('/credit-score')) {
            return 'credit-score';
        } else if (path.includes('/financial-goals')) {
            return 'financial-goals';
        } else if (path.includes('/taxes')) {
            return 'taxes';
        }
        return 'all';
    };

    const { data: skillAssignments, isLoading } = useQuery(['skillAssignments', choosenLanguage], () => getAssignments(choosenLanguage));
    const classes = useStyles()
    const [open, setOpen] = useState(false);
    const [selectedChat, setSelectedChat] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [page, setPage] = useState(0);
    const handleDrawerToggle = () => {
        setOpen(!open);
    };
    const openModal = () => {
        setShowModal(!showModal);
        setOpenTodoModal(false)
    };

    const filteredAssignments = skillAssignments?.filter(assignment =>
        assignment.assignmentName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const assignmentsPerPage = 9;
    const handlePageChange = (event, value) => {
        setPage(value - 1)
    }

    const startIndex = (page) * assignmentsPerPage;
    const endIndex = startIndex + assignmentsPerPage;
    const paginatedAssignments = filteredAssignments?.slice(startIndex, endIndex);

    return (
        <>
            <Box
                sx={{ right: open ? drawerWidth : 0, display: { xs: "none", sm: "block" } }}
                className={classes.skillAssignmentButton} onClick={handleDrawerToggle}>
                {
                    open ? <ArrowForwardIosRoundedIcon sx={{ color: "white" }} /> : <ArrowBackIosNewRoundedIcon sx={{ color: "white" }} />
                }
            </Box>
            {
                isMobile &&
                <Box
                    sx={{ bottom: open ? "85%" : 0, display: { xs: "flex", sm: "none" } }}
                    className={classes.skillAssignmentButtonMobile} onClick={handleDrawerToggle}>
                    {
                        open ? <KeyboardArrowDownRoundedIcon sx={{ color: "white", fontSize: "30px" }} /> : <KeyboardArrowUpRoundedIcon sx={{ color: "white", fontSize: "30px" }} />
                    }
                </Box>
            }
            <StyledDrawer
                anchor={isMobile ? "bottom" : "right"}
                variant="temporary"
                open={open}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <Box
                    sx={{
                        padding: { xs: 2, md: 4 },
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 3
                    }}
                >
                    {selectedChat && !showModal && !openTodoModal ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ width: { xs: "100%", md: "70vw" } }}>
                                <Button
                                    startIcon={<ArrowBackRoundedIcon />}
                                    variant="contained"
                                    onClick={() => setSelectedChat(null)}
                                    sx={{ mb: 2 }}
                                >
                                    {t('global.back')}
                                </Button>
                            </Box>
                            {selectedChat.type === 'image' ? (
                                <img src={selectedChat.iframeLink} alt={t('chatContent')} style={{ width: '100%', height: 'auto' }} />
                            ) : selectedChat.type === 'video' ? (
                                <video controls style={{ width: '100%', height: 'auto' }}>
                                    <source src={selectedChat.iframeLink} type="video/mp4" />
                                    {t('videoNotSupported')}
                                </video>
                            ) : selectedChat.type === 'stickbot' ? (
                                <Box sx={{
                                    height: { md: "80vh", xs: "65vh" },
                                    width: { xs: "100%", md: "70vw" }
                                }}>
                                    <StickbotTop url={selectedChat.iframeLink} />
                                </Box>
                            )
                                : <NoAssignments />
                            }
                        </Box>
                    ) : (
                        !!paginatedAssignments?.length && !showModal && !openTodoModal &&
                        <>
                            <Box sx={{ width: "100%" }}>
                                <Box sx={{ display: "flex", gap: 4 }}>
                                    <Box sx={{ width: { md: "60%", xs: "100%" } }}>
                                        <Typography variant="h4" sx={{
                                            color: "primary.main",
                                            fontWeight: "bold",
                                            mb: 1
                                        }}>
                                            {t('skillAssignments')}:
                                        </Typography>
                                        <Typography variant="h5" sx={{
                                            color: "primary.main",
                                            mb: 3
                                        }}>
                                            {t('interactiveLearningModule')}
                                        </Typography>
                                        <Typography variant="body1" sx={{
                                            fontSize: "16px",
                                            color: "text.secondary",
                                            mb: 4
                                        }}>
                                            {t('exerciseDescription')}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: "40%",
                                            display: { xs: "none", md: "flex" },
                                            justifyContent: "center",
                                            alignItems: "flex-start",
                                            position: "sticky",
                                            top: 0
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src="/assets/img/skill-assignment.png"
                                            alt=""
                                            sx={{
                                                width: "100%",
                                                maxWidth: "400px",
                                                height: "auto",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </Box>
                                </Box>

                                <Box sx={{ display: "flex", gap: { md: 4, xs: 1 }, alignItems: "center", justifyContent: "space-between", mt: 5 }}>
                                    <Typography variant="h4" sx={{
                                        color: "primary.main",
                                        fontWeight: "bold",
                                        mb: 1
                                    }}>
                                        {t('exercises')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        placeholder={t('searchForExercise')}
                                        variant="outlined"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        sx={{
                                            width: { md: "300px", xs: "calc(100% - 100px)" },
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                {paginatedAssignments?.map((assignment, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => setSelectedChat(assignment)}
                                            sx={{
                                                width: '100%',
                                                height: '100px',
                                                justifyContent: 'flex-start',
                                                alignItems: 'flex-start',
                                                padding: '14px',
                                                borderRadius: '12px',
                                                border: '1px solid',
                                                borderColor: 'primary.main',
                                                backgroundColor: 'background.paper',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    backgroundColor: 'action.hover',
                                                }
                                            }}
                                        >
                                            <Box>
                                                <Typography variant="h6" sx={{
                                                    color: 'text.primary',
                                                    fontWeight: 600,
                                                    mb: 1
                                                }}>
                                                    {`Exercise ${index + 1}`}
                                                </Typography>
                                                <Typography variant="body2" sx={{
                                                    color: 'text.secondary'
                                                }}>
                                                    {assignment?.assignmentName}
                                                </Typography>
                                            </Box>
                                        </Button>
                                    </Grid>
                                ))}

                                {
                                    filteredAssignments?.length > assignmentsPerPage &&
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, width: "100%" }}>
                                        <Pagination count={Math.ceil(filteredAssignments?.length / assignmentsPerPage)} color="primary" onChange={handlePageChange} />
                                    </Box>
                                }
                            </Grid>
                        </>
                    )}
                    {
                        !paginatedAssignments?.length && !showModal && !openTodoModal &&
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <NoAssignments />
                        </Box>
                    }

                    {
                        isMobile &&
                        <>
                            <Box sx={{ height: "60px" }} />
                            {showModal && (
                                isStatic ? <StaticNotes /> : <Notes />
                            )}
                            {
                                openTodoModal &&
                                <>
                                    <Button variant="contained" startIcon={<ArrowBackRoundedIcon />} onClick={() => setOpenTodoModal(false)}>
                                        {t('global.back')}
                                    </Button>
                                    {isStatic ? <StaticTodoList page="todoList" /> : <TodoList page="todoList" />}
                                </>
                            }

                            <Box className={classes.fixedBottomButtonsSmallScreen} >
                                <Box className={classes.flexColCenter}>
                                    <ChatBot
                                        data={{ name: "Ameer" }}
                                        pageName={"Skill Section"}
                                    />
                                    <Typography variant="caption" sx={{ color: theme => theme.palette.common.text }}>{t('chat')}</Typography>
                                </Box>

                                <Box className={classes.flexColCenter}>
                                    <IconButton variant="rounded"
                                        onClick={openModal}
                                        sx={{ background: showModal && "red" }}
                                    >
                                        {showModal ? (
                                            <CloseIcon />
                                        ) : (
                                            <NoteAltRoundedIcon />
                                        )}
                                    </IconButton>
                                    <Typography variant="caption" sx={{ color: theme => theme.palette.common.text }}>{t('journal')}</Typography>
                                </Box>
                                <Box className={classes.flexColCenter}>
                                    <GoalsModal />
                                    <Typography variant="caption" sx={{ color: theme => theme.palette.common.text }}>{t('goals')}</Typography>
                                </Box>
                                <Box className={classes.flexColCenter}>
                                    <IconButton variant="rounded" onClick={() => {
                                        setOpenTodoModal(true);
                                        setShowModal(false)
                                    }}>
                                        <FormatListBulletedIcon />
                                    </IconButton>
                                    <Typography variant="caption" sx={{ color: theme => theme.palette.common.text }}>{t('toDo')}</Typography>
                                </Box>
                                <Box className={classes.flexColCenter}>
                                    <DictionaryDialog />
                                    <Typography
                                        variant="caption"
                                        sx={{ color: (theme) => theme.palette.common.text }}
                                    >
                                        {t('dictionary')}
                                    </Typography>
                                </Box>
                                <Box className={classes.flexColCenter}>
                                    <AnalyticsDialog />
                                    <Typography
                                        variant="caption"
                                        sx={{ color: (theme) => theme.palette.common.text }}
                                    >
                                        {t('analytics')}
                                    </Typography>
                                </Box>
                            </Box>
                        </>
                    }

                </Box>
            </StyledDrawer >
        </>
    )
}

export default SkillAssignment